import {
  Alert,
  Button,
  Grid,
  Snackbar,
  Tooltip,
  useMediaQuery,
  CircularProgress,
  Backdrop
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import { AmortCalculationReducerAction } from "../Store/AmortCalculation/AmortCalculationReducer";
import StlapFooter from "../CustomComponents/StlapFooter";
import dayjs from "dayjs";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import store from "../Store";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

const AmortCalculation = () => {
  //Creating Dispatch
  const dispatch = useDispatch();
  //Selecting from store
  const filterValues = useSelector((state) => state.amort.filterValues);
  //Getting value from the store
  const touchHandler = useSelector((data) => data.amort.touchHandler);
  const valueIsValid = useSelector((data) => data.amort.valueIsValid);

  //Error Status checking
  const branchHasError =
    touchHandler.branchTouched && !valueIsValid.branchIsValid;
  const applicationHasError =
    touchHandler.applicationTouched && !valueIsValid.applicationIsValid;

  const [requestedDateValidDateError, setRequestedDateValidDateError] =
    useState(false);

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };
  
  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState(
    "Loading Data Please Wait ....."
  );
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);

  //Branch onChangeHandler
  useEffect(() => {
    getFieldData();
  }, []);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };

  let minDateFromValue = Number(0);
  let maxDateFromValue = Number(0);
  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Amort Request Date Back Count"] &&
        new Date(
          paramValues["Amort Request Date Back Count"]["paramEffStartDate"]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Amort Request Date Back Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateFromValue = 0;
    } else {
      minDateFromValue =
        fieldAccessMap.amortRequestDate &&
        fieldAccessMap.amortRequestDateBackCount
          ? Number(paramValues["Amort Request Date Back Count"]["paramValue"])
          : Number(0);
    }
    if (
      !(
        paramValues["Amort Request Date Future Count"] &&
        new Date(
          paramValues["Amort Request Date Future Count"]["paramEffStartDate"]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Amort Request Date Future Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateFromValue = 0;
    } else {
      maxDateFromValue =
        fieldAccessMap.amortRequestDate &&
        fieldAccessMap.amortRequestDateFutureCount
          ? Number(paramValues["Amort Request Date Future Count"]["paramValue"])
          : Number(0);
    }
  }
  //shortcut key
  const downloadRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keyup", onKeyPressEventHandler);
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    dispatch(
      CommonShortCutAction.removeDefaultShortCutValue({
        event: event,
        screen: "amortCalculation",
      })
    );
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let date = new Date();
    if (event.ctrlKey) {
      if (charCode === "j") {
        downloadRef.current.click();
      } else if (charCode === "i") {
        dispatch(AmortCalculationReducerAction.updateRequestedDate(date));
      } else if (charCode === "p") {
        date.setDate(date.getDate() - 1);
        dispatch(AmortCalculationReducerAction.updateRequestedDate(date));
      } else if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        dispatch(AmortCalculationReducerAction.updateRequestedDate(date));
      }
    }
  };
  useEffect(() => {
    dispatch(AmortCalculationReducerAction.updateBrachIsTouched(false));
    dispatch(
      AmortCalculationReducerAction.updateApplicationNumberIsTouched(false)
    );
    dispatch(AmortCalculationReducerAction.resetFilterValues());
    const branchArr = GetBranchDetails();
    dispatch(AmortCalculationReducerAction.updateBranchArray(branchArr));
  }, []);

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const branchOnChangeHandler = async (value) => {
    dispatch(AmortCalculationReducerAction.updateBranchValue(value));
    if (value && value !== "") {
      dispatch(AmortCalculationReducerAction.updateApplicationValue(null));
      try {
        const branchCodeValue = getSelectedBranchCode(value.label);
        const response = await axios.post("/losCustomer/getLosAppNumByStatus", {
          branch: value.label,
          status: ["Disbursement Completed", "Disbursed", "Requested"],
          branchCode: branchCodeValue,
        });
        dispatch(
          AmortCalculationReducerAction.updateApplicationArray(
            response.data.sort()
          )
        );
      } catch (error) {
        throw Error(error);
      }
    } else {
      // on bank clear.
      dispatch(AmortCalculationReducerAction.updateApplicationArray([]));
      dispatch(AmortCalculationReducerAction.updateApplicationValue(null));
    }
  };

  const downloadButtonHandler = async () => {
    dispatch(AmortCalculationReducerAction.updateBrachIsTouched(true));
    dispatch(
      AmortCalculationReducerAction.updateApplicationNumberIsTouched(true)
    );
    if (
      valueIsValid.branchIsValid &&
      valueIsValid.applicationIsValid &&
      !requestedDateValidDateError
    ) {
      try {
        setLoading(true)
        setLoadingMsg("Downloading amort data...")
        const response = await axios.post(
          "/repayment/getOutStandingAmt",
          {
            applicationNum: filterValues.applicationValue,
            requestedDate: filterValues.requestedDate
              ? dayjs(filterValues.requestedDate).format("M/D/YYYY")
              : null,
          },
          {
            method: "POST",
            responseType: "blob",
          }
        );
        if (response.status === 200) {
          setLoading(false)
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Amort_${filterValues.applicationValue}.xls`
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setMessage("Amort Calculation File Downloaded Successfully.");
          setAlertType("success");
          openAlertHandler();
        } else if (response.status === 206) {
          setLoading(false)
          setMessage("Amort Data Not Available For Requested Date");
          setAlertType("info");
          openAlertHandler();
        }
      } catch (error) {
        setLoading(false)
        setMessage("Amort Calculation File Downloaded Failed.");
        setAlertType("error");
        openAlertHandler();
        throw Error(error);
      }
    }
  };
  return (
    <>
    {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{loadingMsg}</p>
            </Box>
          </Backdrop>
        </>
      )}
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <AccordianContainer
          id="accord"
          title="Amort Calculation"
          initialOpen={true}
          sx={{ margin: "8px !important" }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Branch"
                label="Branch"
                required={true}
                autoCompleteValues={filterValues.branchArray}
                value={filterValues.branchValue}
                onChange={(e, value) => {
                  branchOnChangeHandler(value);
                }}
                onBlur={() => {
                  dispatch(
                    AmortCalculationReducerAction.updateBrachIsTouched(true)
                  );
                }}
              />
              {branchHasError && <p className="error">Please Select Branch</p>}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Application Number"
                label="Application Number"
                required={true}
                autoCompleteValues={filterValues.applicationArray}
                value={filterValues.applicationValue}
                onChange={(event, value) => {
                  dispatch(
                    AmortCalculationReducerAction.updateApplicationValue(value)
                  );
                }}
                onBlur={() => {
                  dispatch(
                    AmortCalculationReducerAction.updateApplicationNumberIsTouched(
                      true
                    )
                  );
                }}
              />
              {applicationHasError && (
                <p className="error">Please Select Application Number</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomDateField
                label="Requested Date"
                variant="standard"
                value={filterValues.requestedDate}
                minDate={new Date().setDate(
                  new Date().getDate() - minDateFromValue
                )}
                maxDate={new Date().setDate(
                  new Date().getDate() + maxDateFromValue
                )}
                onChange={(value) => {
                  dispatch(
                    AmortCalculationReducerAction.updateRequestedDate(value)
                  );
                  if (value !== null && value !== undefined && value !== "") {
                    new Date(value).toDateString() !== "Invalid Date" &&
                    new Date(value).toLocaleDateString().slice(-4) >= "1970" &&
                    new Date(value).toLocaleDateString().slice(-4) <= "2055"
                      ? setRequestedDateValidDateError(false)
                      : setRequestedDateValidDateError(true);

                    const newDateValue = `${new Date(value).getFullYear()}/${
                      new Date(value).getMonth() + 1 > 9
                        ? new Date(value).getMonth() + 1
                        : "0" + new Date(value).getMonth() + 1
                    }/${
                      new Date(value).getDate() > 9
                        ? new Date(value).getDate()
                        : "0" + new Date(value).getDate()
                    }`;
                    const maxValue = new Date().setDate(
                      new Date().getDate() + maxDateFromValue
                    );
                    const maxDateValue = `${new Date(maxValue).getFullYear()}/${
                      new Date(maxValue).getMonth() + 1 > 9
                        ? new Date(maxValue).getMonth() + 1
                        : "0" + new Date(maxValue).getMonth() + 1
                    }/${
                      new Date(maxValue).getDate() > 9
                        ? new Date(maxValue).getDate()
                        : "0" + new Date(maxValue).getDate()
                    }`;

                    const minValue = new Date().setDate(
                      new Date().getDate() - minDateFromValue
                    );
                    const minDateValue = `${new Date(minValue).getFullYear()}/${
                      new Date(minValue).getMonth() + 1 > 9
                        ? new Date(minValue).getMonth() + 1
                        : "0" + new Date(minValue).getMonth() + 1
                    }/${
                      new Date(minValue).getDate() > 9
                        ? new Date(minValue).getDate()
                        : "0" + new Date(minValue).getDate()
                    }`;
                    const specialAccessMaxFlag = newDateValue <= maxDateValue;
                    const specialAccessMinFlag = newDateValue >= minDateValue;
                    specialAccessMaxFlag && specialAccessMinFlag
                      ? setRequestedDateValidDateError(false)
                      : setRequestedDateValidDateError(true);
                  } else {
                    setRequestedDateValidDateError(false);
                  }
                }}
              ></CustomDateField>
              {requestedDateValidDateError && (
                <p className="error">Please Enter Valid Date</p>
              )}
            </Grid>
          </Grid>
          <Box
            sx={{
              marginTop: "12px",
              marginBottom: "8px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Tooltip title="Ctrl+J" placement="top">
              <Button
                variant="contained"
                type="submit"
                sx={{ height: "2rem" }}
                onClick={downloadButtonHandler}
                ref={downloadRef}
              >
                Download
              </Button>
            </Tooltip>
          </Box>
        </AccordianContainer>
      </Box>
      <StlapFooter />
      <Snackbar
        open={alert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};
export default AmortCalculation;
